import { ApiError } from '../identity/types';
import { friendlyErrorMessage } from '../../shared/friendlyError';

/** Module 7 reports a rule/state refusal (e.g. "You cannot approve a payroll run you created yourself.",
 * "Only a payroll run pending approval can be approved.") as a 400, and a concurrent-write race as a 409,
 * each with a hand-authored, user-safe `detail`. The shared `friendlyErrorMessage` replaces any 409 with a
 * generic message, which would hide the server's "reload the run and try again" guidance — so those two
 * statuses show the server's detail here, and everything else (401/403/429/5xx/unknown) still goes through
 * the shared helper unchanged. Never matches on message text for logic — display only. */
const RAW_FALLBACK = /^Request to .+ failed with \d+$/;

export function payrollReviewErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError && (err.status === 400 || err.status === 409) && err.message && !RAW_FALLBACK.test(err.message)) {
    return err.message;
  }
  return friendlyErrorMessage(err, fallback);
}

export function isForbidden(err: unknown): boolean {
  return err instanceof ApiError && err.status === 403;
}

export function isNotFound(err: unknown): boolean {
  return err instanceof ApiError && err.status === 404;
}
